import get from 'lodash.get';
import { isArbitraryObject } from './arbitrary-object.mjs';

const logtoErrorCodes = Object.freeze({
    id_token: {
        invalid_iat: 'Invalid issued at time in the ID token',
        invalid_token: 'Invalid ID token',
    },
    callback_uri_verification: {
        redirect_uri_mismatched: 'The callback URI mismatches the redirect URI.',
        error_found: 'Error found in the callback URI',
        missing_state: 'Missing state in the callback URI',
        state_mismatched: 'State mismatched in the callback URI',
        missing_code: 'Missing code in the callback URI',
    },
    crypto_subtle_unavailable: 'Crypto.subtle is unavailable in insecure contexts (non-HTTPS).',
    unexpected_response_error: 'Unexpected response error from the server.',
});
const getMessageByErrorCode = (errorCode) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const message = get(logtoErrorCodes, errorCode);
    if (typeof message === 'string') {
        return message;
    }
    return errorCode;
};
class LogtoError extends Error {
    constructor(code, data) {
        super(getMessageByErrorCode(code));
        this.code = code;
        this.data = data;
    }
}
const isLogtoRequestError = (data) => {
    if (!isArbitraryObject(data)) {
        return false;
    }
    return typeof data.code === 'string' && typeof data.message === 'string';
};
class LogtoRequestError extends Error {
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
class OidcError {
    constructor(error, errorDescription) {
        this.error = error;
        this.errorDescription = errorDescription;
    }
}

export { LogtoError, LogtoRequestError, OidcError, isLogtoRequestError };
